var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn akkurate-green-btn text-white btn-size",attrs:{"type":"submit","disabled":_vm.isSaving}},[_c('font-awesome-icon',{staticClass:"me-2",attrs:{"icon":['fas', 'save']}}),_vm._v(" "+_vm._s(_vm.processing)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }